import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

const AddDeliveryDialog = ({ open, onClose, onSuccess, token }) => {
  const [deliveryName, setDeliveryName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAdd = async () => {
    if (!deliveryName.trim()) return;
  
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/menu/create-delivery`,
        { deliveryName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      Swal.fire("Success", "Delivery added to menu and items!", "success");
      onSuccess();
      onClose();
    } catch (err) {
      const message =
        err?.response?.data?.message || "Failed to add delivery.";
      onClose(); // Close first
      setTimeout(() => {
        Swal.fire("Error", message, "error").then(() => {
          setDeliveryName("");
          setTimeout(() => {
            document.querySelector("#reopen-delivery-btn")?.click();
          }, 100);
        });
      }, 100);
      console.error("Error adding delivery:", err);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Delivery Option</DialogTitle>
      <DialogContent>
        <TextField
          label="Delivery Name"
          fullWidth
          value={deliveryName}
          onChange={(e) => setDeliveryName(e.target.value)}
          autoFocus
          sx={{ mt: 2 }}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          variant="contained"
          disabled={loading || !deliveryName.trim()}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDeliveryDialog;
